export default __webpack_public_path__ + "static/media/redux-logo.a9567540.svg";